<template>
  <div class='row center-xs'>
    <div class='loader'>
      <vvv-icon :customWidth="size || 60" fillColor="#3D9161" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: ['size']
}
</script>

<style scoped>
.loader {
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
